var $body = $('body');
$(document).ready(function () {

    if($('.product-teaser .product-teaser__title')) {
        $('.row').each(function(i, elem) {
            $(elem).find('.product-teaser .product-teaser__title').matchHeight({byRow: false})
        });
    }

    if ($('.has-sub').hasClass('active')) {
        $('.site-main').addClass('pt-4');
    }

    banner_height();
    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });
    $('.navigation .has-sub .arrow').on('click', function () {
        $(this).parent().siblings('li').removeClass('sub-open').find('.sub-menu').slideUp();
        $(this).parent().toggleClass('sub-open').find('.sub-menu').first().slideToggle();
    });

    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });

    // custom drop down
    $('.custom-dropdown-wrap .selected-val').on('click', function () {
        $('.search-trigger').removeClass('search--open');
        $(this).parent().find('.custom-dropdown').slideToggle('fast').toggleClass('active');
        $(this).parent().toggleClass('open');
    });
    $('.custom-dropdown a').on('click', function (event) {
        var anchor_value = $(this).find('span').text();
        $(this).parent().parent().slideUp().removeClass('active');
        $(this).parents('.custom-dropdown-wrap').removeClass('open').find('.selected-val').text(anchor_value);
    });

    if ($('.landing-slider').length) {
        var landingSlider = $('.landing-slider');
        if (landingSlider.find('.slider-item').length > 1) {
            landingSlider.owlCarousel({
                items: 1,
                loop: true,
                dots: true,
                autoplay: true,
                nav: true,
                touchDrag: true,
                mouseDrag: true,
                autoplayTimeout: 4000,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                onInitialize: function () {
                    if (landingSlider.find('.slider-item').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        }else {
            landingSlider.show();
        }
    }
    if ($('.inner-slider').length) {
        var bannerSlider = $('.inner-slider');
        if (bannerSlider.find('.slider-item').length > 1) {
            bannerSlider.owlCarousel({
                items: 1,
                loop: true,
                dots: false,
                autoplay: true,
                nav: true,
                touchDrag: true,
                mouseDrag: true,
                autoplayTimeout: 4000,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                onInitialize: function () {
                    if (bannerSlider.find('.slider-item').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        }else {
            bannerSlider.show();
        }
    }

    // code for wow initialize
    wow = new WOW({
        mobile: false
    });
    wow.init();

    //Video Element
    if ($('.video-block').length) {
        $('.video-block').each(function(){ 
            var oldUrl = $(this).find('iframe').attr("src"); // Get current url
            var newUrl = oldUrl.replace("autoplay=1", "autoplay=0"); // Create new url
            $(this).find('iframe').attr("src", newUrl); // Set herf value
            console.log();
        });
    
        $('.play-button').on('click', function (ev) {
            var currentUrl = $(this).siblings('.video-block').find("iframe").attr("src"); // Get current url
            var lastUrl = currentUrl.replace("autoplay=0", "autoplay=1"); // Create new url
            $(this).parent('.cover-image').addClass('video-played');
            $(this).siblings('.video-block').find("iframe").attr('src', lastUrl);
            ev.preventDefault();
        });        
    }
    
    // search trigger
    $('.search-trigger a').on('click', function (e) {
        $('.custom-dropdown-wrap').removeClass('open');
        $('.custom-dropdown-wrap .custom-dropdown').slideUp();
        $(this).parent().toggleClass('search--open');
        e.preventDefault();
    })

    $('.search-close-trigger').on('click tap', function () {
        $(this).parents('.search-trigger').removeClass('search--open');
        setTimeout(200);
    });
    // code for tabs on responsive view
    $(".nav-link--responsive").click(function () {
        $(".tab-pane").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).show();

        $(this).parents('.tab-content').find('.nav-link--responsive').removeClass("active");
        $(this).addClass("active");
        scrollVal = $(this).parents('.tab-content').offset().top - header_height();
        $("html, body").animate({ scrollTop: scrollVal }, 1000);
    });
});

$(window).on('load', function () {
    setTimeout(remove_loader, 700);
});

$(window).resize(function () {
    nav_height();
    banner_height();
});

var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    // Fixed Menu
    if (scroll >= 10) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
        if (scroll + $(window).height() > $(document).height() - (header_height() + 35)) {
            $('.goto-top').css('bottom', '300px');
        } else {
            $('.goto-top').css('bottom', '20px');
        }

    } else {
        $('.goto-top').removeClass('visible');
    }

});
var DELAY = 500,
    clicks = 0,
    timer = null;

function isTouchDevice() {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
$(document).on("click", ".has-sub > a", function (e) {
    if (isTouchDevice() === true && (window.matchMedia('(min-width: 993px)').matches) && (window.matchMedia('(max-width: 1200px)').matches)) {
        clicks++;
        if (clicks === 1) {
            timer = setTimeout(function () {
                clicks = 0;
            }, DELAY);
            e.preventDefault();
        } else {
            clearTimeout(timer);
            clicks = 0;
        }
    }
}).on("dblclick", function (e) { });

$(document).on("touchstart click", function (e) {
    container = $('.custom-dropdown-wrap, .search-trigger a, .quick-search form, .search-close-trigger');
    contactInfo = $('');
    if (!container.is(e.target) // if the target of the click isn't the container...
        && container.has(e.target).length === 0 && !contactInfo.is(e.target) && contactInfo.has(e.target).length === 0) {
        $('.custom-dropdown-wrap').removeClass('open');
        $('.custom-dropdown-wrap .custom-dropdown').slideUp();
        $('.search-trigger').removeClass('search--open');
    }
});

function nav_height() {
    if (window.matchMedia('(min-width: 992px)').matches) {
        $('.navigation').css('height', 'auto');
    } else {
        $('.navigation').css('height', win_height() - header_height());
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}
function remove_loader() {
    $('.preloader').hide();
}
function banner_height() {
    $('.landing-slider .slider-item, .inner-slider .slider-item').css('height', win_height() - header_height());
}